import _slicedToArray from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module widget/widgetresize
 */
import Resizer from './widgetresize/resizer.js';
import { Plugin } from '@ckeditor/ckeditor5-core';
import { MouseObserver } from '@ckeditor/ckeditor5-engine';
import { DomEmitterMixin, global } from '@ckeditor/ckeditor5-utils';
import { throttle } from 'lodash-es';
import '../theme/widgetresize.css';
/**
 * The widget resize feature plugin.
 *
 * Use the {@link module:widget/widgetresize~WidgetResize#attachTo} method to create a resizer for the specified widget.
 */
var WidgetResize = /*#__PURE__*/function (_Plugin) {
  _inherits(WidgetResize, _Plugin);
  var _super = _createSuper(WidgetResize);
  function WidgetResize() {
    var _this;
    _classCallCheck(this, WidgetResize);
    _this = _super.apply(this, arguments);
    /**
     * A map of resizers created using this plugin instance.
     */
    _this._resizers = new Map();
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(WidgetResize, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this2 = this;
      var editing = this.editor.editing;
      var domDocument = global.window.document;
      this.set('selectedResizer', null);
      this.set('_activeResizer', null);
      editing.view.addObserver(MouseObserver);
      this._observer = new (DomEmitterMixin())();
      this.listenTo(editing.view.document, 'mousedown', this._mouseDownListener.bind(this), {
        priority: 'high'
      });
      this._observer.listenTo(domDocument, 'mousemove', this._mouseMoveListener.bind(this));
      this._observer.listenTo(domDocument, 'mouseup', this._mouseUpListener.bind(this));
      this._redrawSelectedResizerThrottled = throttle(function () {
        return _this2.redrawSelectedResizer();
      }, 200);
      // Redrawing on any change of the UI of the editor (including content changes).
      this.editor.ui.on('update', this._redrawSelectedResizerThrottled);
      // Remove view widget-resizer mappings for widgets that have been removed from the document.
      // https://github.com/ckeditor/ckeditor5/issues/10156
      // https://github.com/ckeditor/ckeditor5/issues/10266
      this.editor.model.document.on('change', function () {
        var _iterator = _createForOfIteratorHelper(_this2._resizers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              viewElement = _step$value[0],
              resizer = _step$value[1];
            if (!viewElement.isAttached()) {
              _this2._resizers.delete(viewElement);
              resizer.destroy();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }, {
        priority: 'lowest'
      });
      // Resizers need to be redrawn upon window resize, because new window might shrink resize host.
      this._observer.listenTo(global.window, 'resize', this._redrawSelectedResizerThrottled);
      var viewSelection = this.editor.editing.view.document.selection;
      viewSelection.on('change', function () {
        var selectedElement = viewSelection.getSelectedElement();
        var resizer = _this2.getResizerByViewElement(selectedElement) || null;
        if (resizer) {
          _this2.select(resizer);
        } else {
          _this2.deselect();
        }
      });
    }
    /**
     * Redraws the selected resizer if there is any selected resizer and if it is visible.
     */
  }, {
    key: "redrawSelectedResizer",
    value: function redrawSelectedResizer() {
      if (this.selectedResizer && this.selectedResizer.isVisible) {
        this.selectedResizer.redraw();
      }
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(WidgetResize.prototype), "destroy", this).call(this);
      this._observer.stopListening();
      var _iterator2 = _createForOfIteratorHelper(this._resizers.values()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var resizer = _step2.value;
          resizer.destroy();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._redrawSelectedResizerThrottled.cancel();
    }
    /**
     * Marks resizer as selected.
     */
  }, {
    key: "select",
    value: function select(resizer) {
      this.deselect();
      this.selectedResizer = resizer;
      this.selectedResizer.isSelected = true;
    }
    /**
     * Deselects currently set resizer.
     */
  }, {
    key: "deselect",
    value: function deselect() {
      if (this.selectedResizer) {
        this.selectedResizer.isSelected = false;
      }
      this.selectedResizer = null;
    }
    /**
     * @param options Resizer options.
     */
  }, {
    key: "attachTo",
    value: function attachTo(options) {
      var resizer = new Resizer(options);
      var plugins = this.editor.plugins;
      resizer.attach();
      if (plugins.has('WidgetToolbarRepository')) {
        // Hiding widget toolbar to improve the performance
        // (https://github.com/ckeditor/ckeditor5-widget/pull/112#issuecomment-564528765).
        var widgetToolbarRepository = plugins.get('WidgetToolbarRepository');
        resizer.on('begin', function () {
          widgetToolbarRepository.forceDisabled('resize');
        }, {
          priority: 'lowest'
        });
        resizer.on('cancel', function () {
          widgetToolbarRepository.clearForceDisabled('resize');
        }, {
          priority: 'highest'
        });
        resizer.on('commit', function () {
          widgetToolbarRepository.clearForceDisabled('resize');
        }, {
          priority: 'highest'
        });
      }
      this._resizers.set(options.viewElement, resizer);
      var viewSelection = this.editor.editing.view.document.selection;
      var selectedElement = viewSelection.getSelectedElement();
      // If the element the resizer is created for is currently focused, it should become visible.
      if (this.getResizerByViewElement(selectedElement) == resizer) {
        this.select(resizer);
      }
      return resizer;
    }
    /**
     * Returns a resizer created for a given view element (widget element).
     *
     * @param viewElement View element associated with the resizer.
     */
  }, {
    key: "getResizerByViewElement",
    value: function getResizerByViewElement(viewElement) {
      return this._resizers.get(viewElement);
    }
    /**
     * Returns a resizer that contains a given resize handle.
     */
  }, {
    key: "_getResizerByHandle",
    value: function _getResizerByHandle(domResizeHandle) {
      var _iterator3 = _createForOfIteratorHelper(this._resizers.values()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var resizer = _step3.value;
          if (resizer.containsHandle(domResizeHandle)) {
            return resizer;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    /**
     * @param domEventData Native DOM event.
     */
  }, {
    key: "_mouseDownListener",
    value: function _mouseDownListener(event, domEventData) {
      var resizeHandle = domEventData.domTarget;
      if (!Resizer.isResizeHandle(resizeHandle)) {
        return;
      }
      this._activeResizer = this._getResizerByHandle(resizeHandle) || null;
      if (this._activeResizer) {
        this._activeResizer.begin(resizeHandle);
        // Do not call other events when resizing. See: #6755.
        event.stop();
        domEventData.preventDefault();
      }
    }
    /**
     * @param domEventData Native DOM event.
     */
  }, {
    key: "_mouseMoveListener",
    value: function _mouseMoveListener(event, domEventData) {
      if (this._activeResizer) {
        this._activeResizer.updateSize(domEventData);
      }
    }
  }, {
    key: "_mouseUpListener",
    value: function _mouseUpListener() {
      if (this._activeResizer) {
        this._activeResizer.commit();
        this._activeResizer = null;
      }
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'WidgetResize';
    }
  }]);
  return WidgetResize;
}(Plugin);
export { WidgetResize as default };